import { render, staticRenderFns } from "./AccordionItemForTracks.vue?vue&type=template&id=4182b883&scoped=true&"
import script from "./AccordionItemForTracks.vue?vue&type=script&lang=js&"
export * from "./AccordionItemForTracks.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItemForTracks.vue?vue&type=style&index=0&id=4182b883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182b883",
  null
  
)

export default component.exports